export const StatusConstants = {
  DELETE_USER_SUCCESS_CODE: 204,
  DELETE_BUSINESSUNIT_SUCCESS_CODE: 204,
  DELETE_WORKFLOW_TEMPLATE_SUCCESS_CODE: 204,
  DELETE_INSTITUTION_SUCCESS_CODE: 204,
  NOT_FOUND_USER_CODE: 404,
  NOT_FOUND_BUSINESSUNITID_CODE: 404,
  NOT_FOUND_WORKFLOW_TEMPLATE_CODE: 404,
  UNAUTHORIZED_USER_CODE: 401,
  INTERNAL_SERVER_ERROR:500,
  MFA_MAX_ATTEMPT_CODE: "62.01.0039",
  ACC_LOCK_CODE :"62.01.0043",
  PASSWORD_REUSE_REJECTED_CODE: "62.01.0056",
  SSH_KEY_REUSE_REJECTED_CODE: "62.01.0057",
  CREDENTIAL_HISTORY_PERSIST_WARNING_CODE: "62.01.0058",
};
